var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03724 0 0 4.03724 0 9C0 13.9628 4.03724 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03724 13.9628 0 9 0ZM13.2802 8.03025L9.53026 11.7803C9.38401 11.9265 9.19202 12 9 12C8.80798 12 8.61599 11.9265 8.46974 11.7803L4.71976 8.03025C4.42652 7.73701 4.42652 7.263 4.71976 6.96976C5.013 6.67652 5.48701 6.67652 5.78025 6.96976L9 10.1895L12.2198 6.96976C12.513 6.67652 12.987 6.67652 13.2802 6.96976C13.5735 7.263 13.5735 7.73701 13.2802 8.03025Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownToggle);
export default __webpack_public_path__ + "static/media/downToggle.ee2d11601835a16d3c29fd93598d0126.svg";
export { ForwardRef as ReactComponent };